// Unified consent model for all consent-related operations

// Single consent item for array structure (OpenAPI compatible)
export interface ConsentItem {
  consentType: ConsentType;     // Consent type enum value (type-safe)
  granted: boolean;      // Current state
  edited?: boolean;      // Flag to indicate this consent was changed
  timestamp?: string;    // Optional: when it was granted/withdrawn
  version?: string;      // Optional: consent version
}

// Array-based structure for OpenAPI compatibility
export interface UserConsentsArray {
  consents: ConsentItem[];
}

// Backend API response models (matching OpenAPI spec)
export interface ConsentResponse {
  id?: number | null;           // null if consent doesn't exist yet
  consentType: ConsentType;
  granted: boolean;
  grantedAt?: string;           // ISO date string
  withdrawnAt?: string;         // ISO date string
  version?: string;
}

// Request models for consent management
export interface CreateConsentRequest {
  consentType: ConsentType;
  granted: boolean;
  purposeDescription?: string;
  language?: string;
  version?: string;
}

export interface UpdateConsentRequest {
  granted: boolean;
  withdrawalReason?: string;
}


// Enum for consent types (matching backend)
export enum ConsentType {
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  TERMS_OF_USE = 'TERMS_OF_USE',
  MARKETING = 'MARKETING',
  AI_MATCHING = 'AI_MATCHING',
  AI_PARSING = 'AI_PARSING',
  COOKIES = 'COOKIES',
  ANALYTICS = 'ANALYTICS',
  THIRD_PARTY_SHARING = 'THIRD_PARTY_SHARING'
}


// Helper function to create consents for new user/application (returns array format)
export function createNewUserConsents(
  privacyPolicy: boolean,
  termsOfUse: boolean,
  marketing?: boolean,
  aiMatching?: boolean,
  aiParsing?: boolean
): ConsentItem[] {
  const consents: ConsentItem[] = [];

  // Always include required consents
  consents.push({ consentType: ConsentType.PRIVACY_POLICY, granted: privacyPolicy });
  consents.push({ consentType: ConsentType.TERMS_OF_USE, granted: termsOfUse });

  // Include optional consents if provided
  if (marketing !== undefined) {
    consents.push({ consentType: ConsentType.MARKETING, granted: marketing });
  }
  if (aiMatching !== undefined) {
    consents.push({ consentType: ConsentType.AI_MATCHING, granted: aiMatching });
  }
  if (aiParsing !== undefined) {
    consents.push({ consentType: ConsentType.AI_PARSING, granted: aiParsing });
  }

  return consents;
}
